import React from "react";
import { Paper, Typography } from "@material-ui/core";
import { i18n } from "../../../translate/i18n";

const AddConnectionCard = ({ onClick, classes, theme }) => (
  <Paper className={classes.addConnectionCard} onClick={onClick}>
    <Typography className={classes.addConnectionText}>
      <span style={{ fontSize: '32px', marginRight: theme.spacing(1) }}>+</span>
      {i18n.t("connections.addDialog.button")}
    </Typography>
  </Paper>
);

export default AddConnectionCard;
